import { NgIf, NgClass, NgFor, AsyncPipe } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { CurrencyService, OccEndpointsService, TranslatePipe } from '@spartacus/core'
import { CmsComponentData, IconComponent } from '@spartacus/storefront'
import { combineLatest, Observable } from 'rxjs'
import { filter, map, switchMap, take } from 'rxjs/operators'
import { EbGlobalMessageService } from '../../global-message/services/eb-global-message.service'
import { EbUserAccountService } from '../../user/services/eb-user-account.service'
import {
  EbCountryCmsInterface,
  EbSiteContextSelectorComponentData
} from '../interfaces/eb-site-context.interface'
import { EbBaseSiteService } from '../services/eb-base-site.service'
import { EbCountryService } from '../services/eb-country.service'
import { EbLanguageService } from '../services/eb-language.service'
import { EbSiteContextComponentService } from '../services/eb-site-context-component.service'

@Component({
  selector: 'eb-country-selection',
  templateUrl: './eb-country-selection.component.html',
  styleUrls: ['eb-country-selection.component.scss'],
  imports: [NgIf, NgClass, IconComponent, NgFor, AsyncPipe, TranslatePipe]
})
export class EbCountrySelectionComponent implements OnInit {
  activeLanguage$ = this.ebLanguageService.getActive()
  availableCountries$: Observable<any>

  constructor(
    protected ebSiteContextComponentService: EbSiteContextComponentService,
    public component: CmsComponentData<EbCountryCmsInterface>,
    protected ebBaseSiteService: EbBaseSiteService,
    protected ebLanguageService: EbLanguageService,
    protected ebCountryService: EbCountryService,
    protected globalMessageService: EbGlobalMessageService,
    protected occEndpointsService: OccEndpointsService,
    protected ebUserAccountService: EbUserAccountService,
    protected currencyService: CurrencyService
  ) {}

  ngOnInit() {
    this.fetchCountryComponentData()
  }

  get isOpen() {
    return this.ebSiteContextComponentService.getContextSelectionDialogVisibility()
  }

  closeDialog() {
    this.ebSiteContextComponentService.setContextSelectionDialogVisibility(false)
  }

  fetchCountryComponentData() {
    const componentData = this.component.data$ as Observable<EbSiteContextSelectorComponentData>
    let entries
    this.availableCountries$ = componentData.pipe(
      filter(data => !!data.entries?.length),
      switchMap(data => {
        entries = data.entries.split(' ')
        return this.ebSiteContextComponentService.getCountryComponentData(entries)
      }),
      map(countries => {
        countries.sort((a, b) => {
          return entries.indexOf(a.uid) - entries.indexOf(b.uid)
        })
        return countries
      })
    )
  }

  getMatchingContext(country, context) {
    return context.contextItems.find(siteContext => siteContext.uid === country.cmsSite)
  }

  getImageUrl(url: string) {
    const baseUrl = this.occEndpointsService.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false
    })
    return baseUrl + url
  }

  get context$(): Observable<any> {
    return combineLatest([
      this.ebBaseSiteService.getActive(),
      this.ebSiteContextComponentService.getItems(),
      this.ebLanguageService.getActive()
    ]).pipe(
      map(([activeBaseSite, contextItems]) => {
        const activeContext = contextItems.find(contextItem => contextItem.uid === activeBaseSite)
        return {
          activeContext,
          contextItems
        }
      })
    )
  }

  setActiveContext(activatedContext, activatedLanguage) {
    this.ebCountryService
      .getActive()
      .pipe(take(1))
      .subscribe(activeCountry => {
        if (activeCountry !== activatedContext.country.isocode) {
          this.ebCountryService.setActive(activatedContext.country.isocode)
          this.globalMessageService.removeAllMessages()
        }
      })

    this.ebLanguageService.setActive(activatedLanguage)
    this.ebUserAccountService.getEbActiveUserData().subscribe(user => {
      if (user) {
        this.currencyService.setActive(user.currency?.isocode)
      }
    })
    this.closeDialog()
  }
}
